
import Api from '@/utils/api';
import wx from 'weixin-js-sdk'
import MHeader from '../../Header/Header.vue';
import NotData from '../../NoData/NoData.vue';
import BuyerAddress from '../../CreateOrder/BuyerAddress.vue';
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'

export default {
data() {
return {
challenge: {}
}
},
computed: {
},
components: {
MHeader,
Tab,
BuyerAddress,
TabItem,
Swiper,
SwiperItem,
ViewBox,
NotData,
XImg,
Confirm
},
methods: {
},
async mounted() {
const challengeResp = await Api.get('/getInviteChallenge/' + this.$route.query.challengeId)
if (challengeResp.data) {
this.challenge = challengeResp.data
wx.ready(() => {
let title = this.challenge.productInfo.title
let description = '这是' + this.challenge.nickname + '想要的0元好礼，帮他达成心愿吧。'
wx.onMenuShareAppMessage({
title: title,
desc: description,
link: location.href,
imgUrl: this.UPLOAD_DOMAIN + this.challenge.productInfo.thumbnail,
success: function () {
}
})
wx.onMenuShareTimeline({
title: title,
desc: description,
link: location.href,
imgUrl: this.UPLOAD_DOMAIN + this.challenge.productInfo.thumbnail,
success: function () {
}
})
})
}
}
};



// WEBPACK FOOTER //
// ./src/components/UserCenter/invite/inviteChallenge.vue